import { type ReactNode, useState } from 'react';
import { getSdkInstallSnippet, type SdkKey } from '@gonfalon/sdk-info/sdkInfo';

import { trackSdkSetupSnippetClicked } from '../../analytics';
import { SdkSetupSnippet } from '../SdkSetupSnippet/SdkSetupSnippet';

import { installSnippetConfig, type SnippetConfig } from './config';
import type { InstallableSdk } from './types';

interface InstallPackagesProps {
  sdk: InstallableSdk;
}

export const isInstallableSdk = (sdk: SdkKey): sdk is InstallableSdk => {
  return sdk in installSnippetConfig;
};

const resolveEntries = (entries: SnippetConfig['snippets'], sdk: InstallableSdk) =>
  entries.map((entry) => ({
    title: entry.title,
    language: entry.language,
    snippet: getSdkInstallSnippet(sdk, entry.packageManager),
  }));

export const InstallPackages = ({ sdk }: InstallPackagesProps): ReactNode => {
  const { event, withCommandLine, snippets, supplemental } = installSnippetConfig[sdk];

  const [selectedPackageManager, setSelectedPackageManager] = useState(snippets[0]?.title ?? '');

  return (
    <>
      {supplemental?.before?.(selectedPackageManager, setSelectedPackageManager)}
      <SdkSetupSnippet
        withCopyButton
        {...(withCommandLine ? { withCommandLine: true } : { withLineNumbers: true })}
        trackAnalyticsOnClick={() => trackSdkSetupSnippetClicked(event)}
        snippets={resolveEntries(snippets, sdk)}
        selectedSnippetTitle={selectedPackageManager}
        onSelectedSnippetTitleChange={setSelectedPackageManager}
      />
      {supplemental?.after?.(selectedPackageManager, setSelectedPackageManager)}
    </>
  );
};
